import { BoxesIcon, CircleDotIcon, FileTextIcon, GaugeIcon, Grid2X2Icon, LayoutIcon } from 'lucide-react';

import AppSidebar from 'components/app-layout/Sidebar';
import AppSidebarItem from 'components/app-layout/SidebarItem';

export default function PathSiderbar() {
  return <AppSidebar>
    <AppSidebarItem
      to='/path/dashboard'
      icon={GaugeIcon}
      alias='Dashboard'
    />
    <AppSidebarItem
      to='/path/paths'
      icon={Grid2X2Icon}
      alias='Paths'
    />
    <AppSidebarItem
      to='/path/pages'
      icon={FileTextIcon}
      alias='Pages'
    />
    <AppSidebarItem
      to='/path/retargeting'
      icon={CircleDotIcon}
      alias='Retargeting Placements'
    />
    <AppSidebarItem
      to='/path/pixels'
      icon={BoxesIcon}
      alias='Pixels'
    />
    <AppSidebarItem
      to='/path/fields'
      icon={LayoutIcon}
      alias='Custom Fields'
    />
  </AppSidebar>
}
